import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {dateJsonSchema, dateUiSchema} from '@/services/MockData/Order/OrderPriceInfo/DateJSON'
import {discountPromJsonSchema, discountPromUiSchema} from '@/services/MockData/Order/OrderPriceInfo/discountPromJSON'
import {PaymentsAdjJSONSchema, PaymentsAdjJSONUiSchema} from '@/services/MockData/Order/OrderPriceInfo/PaymentsAdjJSON'
import {
  InvoicePriceInfSONSchema,
  InvoicePriceInfSONUiSchema,
} from '@/services/MockData/Order/OrderPriceInfo/InvoicePriceInfSON'
import {PageContainer} from '@/components/organisms'
import {SectionTitle} from '@/components/molecules'

const OrderPriceInfoPage = ({OrderDetails}) => {
  const {
    createdDateTime,
    subTotal,
    invoiceDateTime,
    orderType,
    orderLocationId,
    sourceOrderId,
    customerPold,
    routeId,
    routeTypeId,
    routeSalesRepWorkForceId,
    rejectionReasonDescription,
  } = OrderDetails

  // Helper component to render each section
  const RenderSection = ({id, label, jsonSchema, uiSchema, data}) => (
    <div>
      <SectionTitle isBorderVisible={true} id={id} label={label} />
      <div className="pt-5">
        <JsonFormsWrapper jsonschema={jsonSchema} uischema={uiSchema} data={data} />
      </div>
    </div>
  )

  return (
    <PageContainer>
      {/* MXN (Mexican Peso) Section */}
      <RenderSection
        id="mxn"
        label="MXN (Mexican Peso)"
        jsonSchema={dateJsonSchema}
        uiSchema={dateUiSchema}
        data={{
          orderTotal: createdDateTime,
          subTotalPrice: subTotal,
          taxableAmount: invoiceDateTime,
          totalGiftTaxAmount: invoiceDateTime,
          returnsTotal: invoiceDateTime,
        }}
      />

      {/* Discounts and Promotions Section */}
      <RenderSection
        id="dis_pro"
        label="Discounts and Promotions"
        jsonSchema={discountPromJsonSchema}
        uiSchema={discountPromUiSchema}
        data={{
          contractDiscount: orderType,
          promotionalDiscount: orderLocationId,
          estimatedPromotionalPoints: sourceOrderId,
          promotionalPoints: customerPold,
        }}
      />

      {/* Payments and Adjustments Section */}
      <RenderSection
        id="payments_adjustments"
        label="Payments and Adjustments"
        jsonSchema={PaymentsAdjJSONSchema}
        uiSchema={PaymentsAdjJSONUiSchema}
        data={{
          pointDeducted: routeId,
          totalPoints: routeTypeId,
          topUpPaymentAmount: routeSalesRepWorkForceId,
          totalDepositAmount: rejectionReasonDescription,
        }}
      />

      {/* Invoice Price Information Section */}
      <RenderSection
        id="invoice_price_information"
        label="Invoice Price Information"
        jsonSchema={InvoicePriceInfSONSchema}
        uiSchema={InvoicePriceInfSONUiSchema}
        data={{
          totalGrossAmount: routeId,
          totalTaxAmount: routeTypeId,
          totalDiscountAmount: routeSalesRepWorkForceId,
          totalPromotionAmount: rejectionReasonDescription,
          totalNetPrice: rejectionReasonDescription,
          points: rejectionReasonDescription,
        }}
      />
    </PageContainer>
  )
}

export default OrderPriceInfoPage
